<template>
    <div>
        <span v-text="value"  v-if="!isEdit" :class="classes" @dblclick="toggle"></span>
        <select v-model="value"
                v-if="isEdit"
                class="custom-select-sm"
                @change="onChange"
                @blur="onBlur"
                autofocus
        >
            <option v-for="item in items"
                    :value="item.id_articolo"
                    v-text="`${item.id_articolo} | ${item.descrizione} - ${item.descrizione_ridotta}`"
                    :selected="data == item.id_articolo ? true : false"
            >

            </option>
        </select>
    </div>
</template>

<script>
    import EditCell from '../mixins/EditCell';

    export default {

        mixins: [EditCell],

        props: ['item_type'],

        data() {
            return {
                items: '',
            }
        },

        methods: {
            toggle() {

                if (this.isEdit) {
                    this.isEdit = false;
                    return;
                }

                this.fetch();
                this.isEdit = true;
            },

            fetch() {
                axios.get(`/items?type=${this.item_type}`)
                    .then(({data}) => this.items = data);
            }
        }

    }
</script>